import { footerData, navLinks, heroData, images } from "../../data/mock";
import { Separator } from "../ui/separator";
import { Facebook, Instagram, Youtube, Twitter, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

const socialIconMap = {
  Facebook: Facebook,
  Instagram: Instagram,
  Youtube: Youtube,
  Twitter: Twitter
};

export const Footer = () => {
  const navigate = useNavigate();

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-brand-950 pt-20 pb-8 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-brand-light/3 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={images.logoBlue}
                alt="Tu Iglesia App"
                className="h-14 w-auto"
              />
            </div>
            <p className="text-white/35 text-sm leading-relaxed mb-6">
              {footerData.tagline}
            </p>
            <div className="flex gap-3">
              {footerData.socialLinks.map((social) => {
                const Icon = socialIconMap[social.icon];
                return (
                  <button
                    key={social.name}
                    className="w-10 h-10 rounded-xl bg-white/5 border border-white/8 flex items-center justify-center hover:bg-brand-light/15 hover:border-brand-light/25 transition-all duration-300 group"
                    aria-label={social.name}
                  >
                    <Icon className="w-4 h-4 text-white/40 group-hover:text-brand-light transition-colors" />
                  </button>
                );
              })}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="brand-heading text-white font-bold mb-5 text-sm uppercase tracking-wider">
              Navegación
            </h4>
            <div className="space-y-3">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href)}
                  className="block text-white/35 hover:text-brand-light text-sm transition-colors duration-300"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Inversores */}
          <div>
            <h4 className="brand-heading text-white font-bold mb-5 text-sm uppercase tracking-wider">
              Inversores
            </h4>
            <button
              onClick={() => navigate("/inversores")}
              className="flex items-center gap-2 text-white/35 hover:text-brand-light text-sm transition-colors duration-300 group"
            >
              <Lock className="w-3.5 h-3.5 group-hover:text-brand-light transition-colors" />
              Portal de Inversores
            </button>
            <p className="text-white/15 text-xs mt-3 leading-relaxed">
              Acceso exclusivo con clave para inversores autorizados.
            </p>
          </div>

          {/* Verse */}
          <div>
            <h4 className="brand-heading text-white font-bold mb-5 text-sm uppercase tracking-wider">
              Palabra
            </h4>
            <div className="p-5 rounded-2xl bg-white/[0.03] border border-brand-light/8">
              <p className="text-white/30 italic text-sm leading-relaxed">
                {footerData.verse.text}
              </p>
              <p className="text-brand-light/35 text-xs mt-3 font-bold">
                {footerData.verse.reference}
              </p>
            </div>
          </div>
        </div>

        <Separator className="bg-white/5 mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-sm">
            {new Date().getFullYear()} {heroData.title}. Todos los derechos reservados.
          </p>
          <a
            href={`https://${footerData.website}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-light/30 hover:text-brand-light text-sm transition-colors"
          >
            {footerData.website}
          </a>
        </div>
      </div>
    </footer>
  );
};
